var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseExportContact", {
    attrs: {
      postFixer: "fireMarshal",
      inputRequireHighlight: _vm.inputRequireHighlight,
      maxBuildingsPerExport: _vm.maxBuildingsPerExport,
      selectedBuildings: _vm.selectedBuildings,
    },
    on: {
      "update:selectedBuildings": function ($event) {
        _vm.selectedBuildings = $event
      },
      "update:selected-buildings": function ($event) {
        _vm.selectedBuildings = $event
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }